module.exports = __webpack_public_path__ + "media/images/coupon/add-4db4874b5dc85905069d58c04216222f.svg";